import notes from './Notes';
import actions from './actions';
import mutations from './mutations';

const INITIAL_STATE = {
  connections: {
    list: [],
    page: 1,
    filters: {
      calling_number: [],
      widget_id_fk: [],
      date: [],
      agent_id: [],
      session_id: [],
      notify_status: [],
      effect: [],
      direction: [],
    },
  },
  settings: {
    notifyStatuses: [],
  },
};

const getters = {
  connectionsSettings: state => state.settings,
  connections: state => state.connections,

  // obiekt filtrów
  connectionsFilters: state => state.connections.filters,
};

// VUEX MODULE /////////////////////////////////////////////////////////////////
const Module = {
  modules: {
    notes,
  },
  namespaced: true,
  state: INITIAL_STATE,
  mutations,
  actions,
  getters,
};

export default Module;
